var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('PageIntro',{attrs:{"heading":'Your <span>' +_vm.configStrings.productName + '</span> account',"body":'<p>You must set a new password.</p>'}}),_c('SetNewPasswordForm'),_c('FooterShout',{attrs:{"type":'signin'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }